/**
 * The build's identity, as the About page and the sidebar caption show it.
 * `appBuild.config.ts` (beside `vite.config.ts`) writes it into the bundle as
 * `__APP_BUILD__`; this reads it back.
 */
export interface AppBuild {
  version: string;
  commit: string;
  /** ISO timestamp of the build, or `UNKNOWN`. */
  builtAt: string;
  /** A dev server or local build: the page says so instead of naming a commit. */
  development: boolean;
}

export const UNKNOWN = 'unknown';

function text(value: unknown): string {
  return typeof value === 'string' && value.trim() ? value : UNKNOWN;
}

/**
 * `__APP_BUILD__` is undefined wherever the Vite `define` did not run (the test
 * environment), and every value then reads `UNKNOWN`.
 */
export function readBuildInfo(): AppBuild {
  const injected: Partial<AppBuild> | undefined =
    typeof __APP_BUILD__ === 'undefined' ? undefined : __APP_BUILD__;
  return {
    version: text(injected?.version),
    commit: text(injected?.commit),
    builtAt: text(injected?.builtAt),
    development: injected?.development === true,
  };
}
